import { render, staticRenderFns } from "./responseCell.vue?vue&type=template&id=0fb4f5bc&scoped=true&"
import script from "./responseCell.vue?vue&type=script&lang=js&"
export * from "./responseCell.vue?vue&type=script&lang=js&"
import style0 from "./responseCell.vue?vue&type=style&index=0&id=0fb4f5bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb4f5bc",
  null
  
)

export default component.exports